import React from "react";

import { useTranslation } from "react-i18next";

import { Alert, AlertDescription } from "@/src/components/ui/alert";
import { Button } from "@/src/components/ui/button";

import type { JSX } from "react";

interface LoadErrorAlertProps {
  message: string;
  onRetry: () => void;
}

function LoadErrorAlert({
  message,
  onRetry,
}: LoadErrorAlertProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");

  return (
    <Alert variant="destructive">
      <AlertDescription className="flex items-center justify-between gap-3">
        {message}
        <Button onClick={onRetry} type="button" variant="outline">
          {t("retry")}
        </Button>
      </AlertDescription>
    </Alert>
  );
}

export default LoadErrorAlert;
